import { Injectable, Injector } from '@angular/core';
import { Http, Headers, RequestOptions, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';
import { AppSettings } from '@app/common/app-setting';
import { HTTP_INTERCEPTORS, HttpClient, HttpHeaders } from '@angular/common/http';
import { AutharizedEndPointService } from '@app/services/base-service/autharized-endpoint.service';
import { TransactionFilterModel } from '@app/models/Transaction-Filter-model';

@Injectable()
export class LoyaltyEndpoint extends AutharizedEndPointService{
    http1: HttpClient;
    _baseurl = `${AppSettings.API_ENDPOINT}`;
    private readonly _getloyaltyUrl: string = 'api/CustomerReportManagement/CustomerLoyaltyTransaction';
    private readonly _getLoyaltyPdfExcelUrl: string = 'api/CustomerReportManagement/CustomerLoyaltyTransactionPdfExcel';
    constructor(http: HttpClient) {
        super(http, 'UserManagement/Roles');
        this.http1 = http;
    }

    getUrl(url: string) {
        return this._baseurl + url;
    }
    
    getLoyalty(trans: TransactionFilterModel){
        return this.http1.post(this.getUrl(this._getloyaltyUrl),trans,this.AddAuthToken());
    }
    getLoyaltyPdfExcel(trans: TransactionFilterModel){
        return this.http1.post(this.getUrl(this._getLoyaltyPdfExcelUrl),trans,this.AddAuthToken());
    }

}


// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-endpoints.service.ts